<template lang="pug">
    v-select(v-model="select" solo dense outlined :rules="rules"  item-text="name" item-value="value" :items="bizTypes" :placeholder="$t('Placeholder.__Industry')" :disabled="disabled" :readonly="readonly")

</template>
<script>
export default {
  props: {
    value: {
      type: String
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      select: null,
      bizTypes: []
    }
  },
  watch: {
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    }
  },
  methods: {
    getBizTypes() {
      this.$store
        .dispatch("bizes/getBizTypes")
        .then(
          function(response) {
            this.bizTypes = response.data.businessTypes
          }.bind(this)
        )
        .catch(
          function(error) {
            this.alertText = error.message
          }.bind(this)
        )
    }
  },
  mounted() {
    this.getBizTypes()
    this.select = this.value
  }
}
</script>
